import { SetState, GetState } from 'zustand';
import { IPersonalAccount, IPrimaryAccount } from '../types';

export interface IAccountSummarySlice {
    summary: any;
    setSummary: (accountSummary: any) => void;
    getSummaryData: () => any;
    getPersonalAccount: () => IPersonalAccount;
    getPrimaryAccount: () => IPrimaryAccount;
    getPersonExternalId: () => string;
    getPersonalAccountId: () => string;
    resetAccountSummary: () => void;
    getAccountBank: () => string;
}

const createAccountSummarySlice = (set: SetState<IAccountSummarySlice>, get: GetState<IAccountSummarySlice>) => ({
  summary: null,
  setSummary: (accountSummary: any) => {
    set({
      summary: accountSummary,
    });
  },
  resetAccountSummary: () => {
    set({ summary: null });
  },
  getPersonExternalId: () => get().summary?.personExternalId || '',
  getPersonalAccountId: () => get().summary?.accounts?.[0].accountExternalId || '',
  getSummaryData: () => get().summary,
  getPersonalAccount: () => get().summary?.accounts?.[0] as IPersonalAccount,
  getPrimaryAccount: () => get().summary.primaryAccount as IPrimaryAccount || get().summary.accounts[0] as IPrimaryAccount,
  getAccountBank: () => {
    const { getPrimaryAccount } = get();
    return getPrimaryAccount().bankInfo.bank;
  },
});

export default createAccountSummarySlice;
